import { render, staticRenderFns } from "./FeaturedVendorCard.vue?vue&type=template&id=0dc6351a&"
import script from "./FeaturedVendorCard.vue?vue&type=script&lang=js&"
export * from "./FeaturedVendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dc6351a')) {
      api.createRecord('0dc6351a', component.options)
    } else {
      api.reload('0dc6351a', component.options)
    }
    module.hot.accept("./FeaturedVendorCard.vue?vue&type=template&id=0dc6351a&", function () {
      api.rerender('0dc6351a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/vendor-partners/cards/FeaturedVendorCard.vue"
export default component.exports